import { PropertyType, ToolProvider } from '@/backend/types'
import { defaultToolConfig } from '@/modules/Project/Tools/tool-config-presets'
import type { ToolRegistryItem } from '@/modules/Project/Tools/tool-types'

export const o4MiniTool: ToolRegistryItem = {
  ...defaultToolConfig,
  label: 'o4 Mini',
  description:
    'o4-mini is OpenAI’s latest small reasoning model, optimized for coding, math, and science tasks. It delivers faster responses than o3.',
  outputTypes: [
    PropertyType.text,
    PropertyType.single_select,
    PropertyType.multi_select,
    PropertyType.hub_select,
    PropertyType.json,
    PropertyType.collection,
    PropertyType.url,
    PropertyType.reference,
    PropertyType.number,
  ],
  provider: ToolProvider.open_ai,
  addedAt: new Date('2025-04-23'),
  isRateLimited: true,
  icon: 'company-openai',
}
